var _ref2, _ref3;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgGarmin = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      id: "Layer_2",
      viewBox: "0 0 14.63 21.53",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("defs", null,
    /*#__PURE__*/
    React.createElement("style", null, ".cls-1{stroke-width:0px;}"))), _ref3 || (_ref3 =
    /*#__PURE__*/
    React.createElement("g", {
      id: "_004-brush"
    },
    /*#__PURE__*/
    React.createElement("path", {
      id: "_002-watch",
      className: "cls-1",
      d: "m12.78,3.82s-1.52-.59-1.52-.59l-.45-2.81C10.77.17,10.57,0,10.33,0H3.69c-.24,0-.45.17-.48.41l-.45,2.81s-1.5.58-1.52.59c-.72.2-1.22.84-1.24,1.59v10.76c.05.76.58,1.4,1.31,1.6h0l1.44.55.45,2.81c.04.24.24.41.48.41h6.63c.24,0,.45-.17.48-.41l.45-2.81,1.45-.56c.73-.2,1.26-.84,1.31-1.6v-2.97h.61v-1.85h-.61v-1.94h.61v-1.85h-.61v-2.15c-.04-.74-.54-1.37-1.25-1.59Zm-.33,11.44c0,.53-.43.96-.96.96H2.53c-.53,0-.96-.43-.96-.96h0V6.3c0-.53.43-.96.96-.96h8.96c.53,0,.96.43.96.96h0v8.96h0Z"
    }))))
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgGarmin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Garmin.7f70a538.svg";
export { ForwardRef as ReactComponent };